export const WELCOME_COURSE_IDS = [
  '5771f05d14aae69912bad0d7',
  '584ecbb7261e9fe97149376a',
]

export const LGBTQ_COURSE_IDS = [
  '5b2e730e9915850019fbed01',
  '5c9e6480ea16af729dd36bf6',
]
